module.exports = __webpack_public_path__ + "static/key-forager-a104751d724cf8f371c435db99283497.webp";